module.exports = __webpack_public_path__ + "img/FV.248ba3f0.png";